import React from 'react';
import { AutoComplete as CAutoComplete, Button, Divider } from 'antd';

interface IProps {
  children?: React.ReactNode;
  options: any;
  style?: any;
  onFocus?: () => void;
  onBlur?: () => void;
  open: boolean;
  allowClear?: boolean;
  showMore?: boolean;
  showSearch?: boolean;
  popupClassName?: string;
  placeholder?: string;
  popupMatchSelectWidth?: boolean | number;
  onSelect?: (value: any, option: any) => void;
  onSearch?: (value: any) => void;
  onShowMore?: () => void;
  listHeight?: number;
  value?: any;
  renderShowMore?: React.ReactNode;
}

const AutoComplete: React.FC<IProps> = ({
  children,
  options,
  style,
  onFocus,
  onBlur,
  onSelect,
  open,
  popupClassName,
  placeholder,
  popupMatchSelectWidth,
  allowClear = false,
  onShowMore,
  showMore,
  showSearch,
  value,
  renderShowMore,
  onSearch
}) => (
  <CAutoComplete
    open={open}
    options={options}
    style={style}
    placeholder={placeholder}
    popupClassName={popupClassName}
    onBlur={onBlur}
    onFocus={onFocus}
    onSelect={onSelect}
    value={value}
    popupMatchSelectWidth={popupMatchSelectWidth}
    showSearch={showSearch}
    allowClear={allowClear}
    onSearch={onSearch}
    // filterOption={(inputValue, option) => {
    //   if (!showSearch) {
    //     return false;
    //   } else {
    //     return ((option?.value ?? '').toLowerCase()).includes(inputValue.toLowerCase());
    //   }
    // }}
    dropdownRender={(menus) => {
      return (
      <div>
        {menus}
        {showMore &&
          <React.Fragment>
            <Divider style={{ margin: '8px 0' }} />
            <div onMouseDown={(e) => e.preventDefault()}>
            {renderShowMore}
            </div>
          </React.Fragment>
        }
      </div>
    )
    }}
  >
    {children}
  </CAutoComplete>
);

export default AutoComplete;
